import { cfdActions } from '~/renderer/store/cfd';
import { setConfig } from '~/renderer/utils/config';

import type { AnyAction, Dispatch, Middleware } from '@reduxjs/toolkit';
import type { AppState } from '~/renderer/store/types';

export const config: Middleware<AnyAction, AppState> =
  () => (next: Dispatch) => (action: AnyAction) => {
    if (cfdActions.updateOptions.match(action)) {
      setConfig(action.payload);
    }

    return next(action);
  };
